const state = {
  title: null,
  message: null,
  callback: null,
  payload: null,
  cancelCallback: null,
  cancelPayload: null,
  show: false
}

const getters = {
  alert_show: (state) => {
    return state.show
  },
  message: (state) => {
    return state.message
  },
  title: (state) => {
    return state.title
  },

}

const actions = {}

const mutations = {
  alert_fire(state, data) {
    state.title = data.title
    state.message = data.message
    state.callback = data.callback
    state.payload = data.payload || null
    state.cancelCallback = data.cancelCallback
    state.cancelPayload = data.cancelPayload || null
    state.show = true
  },
  alert_close(state) {
    if(state.cancelCallback){
      !state.cancelPayload ? state.cancelCallback() : state.cancelCallback(state.cancelPayload)
    }
    this.commit('alert/reset')
  },
  alert_confirm(state) {
    !state.payload ? state.callback() : state.callback(state.payload)
    this.commit('alert/reset')
  },
  reset(state) {
    state.title = null
    state.message = null
    state.callback = null
    state.payload = null
    state.show = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
